export default {
  data() {
    return {
      observedMap: new Map(),
      visibleSet: new Set(),
      observer: null
    }
  },
  methods: {
    registerElement(el, name) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = el?.$el ?? el
          if (!element || !(element instanceof HTMLElement)) return

          const previous = this.observedMap.get(name)
          if (previous && previous !== element) {
            this.observer?.unobserve(previous)
          }

          if (!this.observedMap.has(name) || this.observedMap.get(name) !== element) {
            this.observedMap.set(name, element)
            this.observer?.observe(element)
          }
        }, 100)
      })
    },

    initObserver() {
      if (this.observer) return

      this.observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            const target = entry.target
            const name = [...this.observedMap.entries()].find(([_, el]) => el === target)?.[0]

            if (!name) continue

            if (entry.isIntersecting) {
              this.visibleSet.add(name)
            } else {
              this.visibleSet.delete(name)
            }
          }
        },
        {
          threshold: 0,
          rootMargin: '100% 0px'
        }
      )
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeUnmount() {
    this.observer?.disconnect()
    this.observer = null
    this.observedMap.clear()
    this.visibleSet.clear()
  },
  unregisterElement(el) {
    const element = el?.$el ?? el
    if (!element) return

    for (const [name, elRef] of this.observedMap.entries()) {
      if (elRef === element) {
        this.observer?.unobserve(elRef)
        this.observedMap.delete(name)
        this.visibleSet.delete(name)
        break
      }
    }
  }
}
